$(function(){
  //init
  workSwiperFunc();
  memberSwiperFunc();

  ////////////////////////////////////////////////////////////////////////////

  //ホバー時停止処理(swiper)
  function swiperPauseOnHover(element, swiperInit) {
    element.addEventListener('mouseover', function() {
      swiperInit.autoplay.stop();
    });
    element.addEventListener('mouseleave', function() {
      swiperInit.autoplay.start();
    });
  }

  function swiperCtrlBtn(swiperInit, prevElm, nextElm) {
    prevElm.addEventListener('click', function(e) {
      e.preventDefault();
      swiperInit.slidePrev();
    });
    nextElm.addEventListener('click', function(e) {
      e.preventDefault();
      swiperInit.slideNext();
    });
  }

  ////////////////////////////////////////////////////////////////////////////

  function workSwiperFunc() {
    const initFlag = document.querySelectorAll(".js-workSlide");

    if (initFlag.length > 0) {
      const sliderElm = document.querySelector('.js-workSlide');
      const prevBtn = document.querySelector('.js-workPrev');
      const nextBtn = document.querySelector('.js-workNext');
      const workSwiper = new Swiper(".js-workSlide", {
        slidesPerView: 'auto',
        loop: true,
        loopAdditionalSlides: 2,
        grabCursor: false,
        centeredSlides : true,
        allowTouchMove: true,
        autoHeight: false,
        speed: 1000,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      });

      swiperCtrlBtn(workSwiper, prevBtn, nextBtn);
      swiperPauseOnHover(sliderElm, workSwiper);
    }
  }

  ////////////////////////////////////////////////////////////////////////////

  function memberSwiperFunc() {
    const initFlag = document.querySelectorAll(".js-memberSlide");

    if (initFlag.length > 0) {
      const sliderElm = document.querySelector('.js-memberSlide');
      const prevBtn = document.querySelector('.js-memberPrev');
      const nextBtn = document.querySelector('.js-memberNext');
      const memberSwiper = new Swiper(".js-memberSlide", {
        slidesPerView: 'auto',
        loop: true,
        loopAdditionalSlides: 2,
        grabCursor: false,
        centeredSlides : true,
        allowTouchMove: true,
        autoHeight: false,
        speed: 1000,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
      });

      swiperCtrlBtn(memberSwiper, prevBtn, nextBtn);
      swiperPauseOnHover(sliderElm, memberSwiper);
    }
  }

});